{
  "nav": {
    "home": "Início",
    "pick": "Escolhas",
    "leaderboard": "Classificação",
    "profile": "Perfil",
    "leagues": "Ligas",
    "active_league": "Liga Ativa"
  },
  "common": {
    "error_data": "Erro ao carregar os dados.",
    "stage": "Etapa",
    "go": "IR",
    "back": "← Voltar",
    "one_day_race": "Prova de um dia",
    "tomorrow": "Amanhã",
    "in_days_one": "Amanhã",
    "in_days_many": "Em {{count}} dias",
    "in_days_other": "Em {{count}} dias",
    "at_hours": "Às {{hours}} horas",
    "loading": "Carregando...",
    "confirm": "CONFIRMAR",
    "logout": "SAIR",
    "in_days": "Em {{count}} dias",
    "error_generic": "Ocorreu um erro.",
    "optional": "opcional",
    "tu": "TU",
    "error_title": "Erro",
    "send": "Enviar",
    "retry": "Tentar novamente",
    "load_error_title": "Não foi possível carregar os dados",
    "load_error_sub": "Verifica a tua ligação e tenta novamente.",
    "stale_data": "Dados desatualizados: a mostrar os guardados."
  },
  "home": {
    "participants": "participantes",
    "section_results": "Últimos resultados",
    "section_upcoming": "Próximas provas",
    "social": "Segue-nos nas redes sociais",
    "onboarding_next": "Seguinte →",
    "onboarding_start": "Começa a jogar →",
    "onboarding_rules": "Ler o regulamento",
    "section_picks": "Escolhas a fazer",
    "no_races": "Sem provas para escolher no momento",
    "other_picks_one": "mais uma escolha a fazer →",
    "other_picks_many": "mais {{count}} escolhas a fazer →",
    "other_picks_other": "mais {{count}} escolhas a fazer →",
    "stage_results": "Classificação",
    "tab_stage": "ETAPA",
    "tab_gc": "GERAL",
    "no_data": "Sem dados disponíveis",
    "onboarding_step1_title": "Bem-vindo ao Virtua Cycling!",
    "onboarding_step1_body": "O jogo fantasy do ciclismo profissional.",
    "onboarding_step2_title": "Como funciona",
    "onboarding_item1": "Escolhe os teus corredores — Antes de cada etapa, escolhe os corredores em quem apostas. Tens tempo até à partida.",
    "onboarding_item2": "Ganha pontos — Os teus corredores ganham pontos com base na classificação real na etapa e na geral.",
    "onboarding_item3": "Cria a tua liga — Compete com os outros participantes etapa a etapa e sobe na classificação geral.",
    "onboarding_step3_title": "Estás pronto!",
    "onboarding_step3_body": "Estás na Virtua Cycling League, a liga geral onde todos jogam. Lê o regulamento completo para não perderes nada.",
    "kofi_cta": "Gostas da app? Oferece-nos uma cerveja!",
    "jersey_gc": "Camisola líder da geral",
    "jersey_pt": "Camisola de pontos",
    "jersey_gm": "Camisola da montanha",
    "greeting": "Olá, {{name}}",
    "status_ready": "Escolhas confirmadas para a próxima etapa",
    "status_todo": "Ainda não fizeste as tuas escolhas",
    "retry": "Tentar novamente"
  },
  "pick": {
    "live_label": "AO VIVO",
    "pick_done": "Escolhas já efetuadas — ainda podes alterá-las",
    "no_pick_stage": "Não foi encontrada nenhuma escolha para esta etapa.",
    "error_load": "Erro ao carregar as provas.",
    "loading": "Carregando...",
    "title": "Escolhas",
    "no_races_title": "Nenhuma prova disponível",
    "no_races_sub": "Não há provas agendadas no momento. Volta em breve!",
    "banned_title": "Retirada da prova",
    "banned_stages_one": "Perdeste 1 etapa",
    "banned_stages_many": "Perdeste {{count}} etapas",
    "banned_stages_other": "Perdeste {{count}} etapas",
    "banned_detail": "Podes acompanhar os resultados e as escolhas dos outros, mas não podes participar nesta edição.",
    "banned_message": "Até à próxima!",
    "stage_finished": "Etapa concluída. Aqui estão as escolhas efetuadas.",
    "live_alert": "Prova em curso — formações alinhadas",
    "startlist_btn": "Lista de partida",
    "startlist_title": "Lista de partida",
    "startlist_search": "Procurar dorsal ou nome",
    "startlist_dnf": "Desistiu",
    "startlist_empty": "Lista de partida ainda indisponível",
    "tab_insert": "Inserção",
    "tab_summary": "Resumo",
    "start_list_title": "Lista de partida ainda não disponível",
    "start_list_sub": "A lista de participantes será publicada em breve. Volta a verificar mais tarde.",
    "need_more_one": "Seleciona mais {{count}} corredor.",
    "need_more_many": "Seleciona mais {{count}} corredores.",
    "need_more_other": "Seleciona mais {{count}} corredores.",
    "error_save": "Erro ao guardar.",
    "loading_riders": "A carregar corredores...",
    "draft_restored": "Rascunho restaurado",
    "draft_count_one": "1 corredor guardado localmente",
    "draft_count_many": "{{count}} corredores guardados localmente",
    "draft_count_other": "{{count}} corredores guardados localmente",
    "draft_cancel": "Cancelar",
    "select_n_one": "Seleciona {{count}} corredor",
    "select_n_many": "Seleciona {{count}} corredores",
    "select_n_other": "Seleciona {{count}} corredores",
    "add_rider": "+ Adicionar corredor ({{current}}/{{limit}})",
    "edit_selection": "Editar seleção",
    "apply_all": "Aplicar a escolha a todas as minhas ligas",
    "saved_for": "Guardado para: {{leagues}}",
    "flip_used": "Flip — utilizado",
    "flip_available": "Flip — disponível",
    "flip_remove": "Remover",
    "flip_abbinato": "{{rider}} associado ao slot {{slot}}",
    "flip_confirmed": "O flip foi declarado para esta etapa. No cálculo de pontos será escolhido o melhor.",
    "flip_slot_label": "Associar o flip a que slot?",
    "flip_confirm_btn": "Confirmar flip",
    "saving": "A guardar...",
    "confirm_pick": "CONFIRMAR ESCOLHA {{current}}/{{limit}}",
    "select_riders": "Selecionar corredores",
    "search_rider": "Procurar corredor...",
    "no_rider_found": "Nenhum corredor encontrado",
    "compare_users": "Comparar utilizadores",
    "confirm": "Confirmar",
    "no_pick_found": "Nenhuma escolha encontrada.",
    "toast_multi_one": "Escolhas guardadas em 1 liga",
    "toast_multi_many": "Escolhas guardadas em {{count}} ligas",
    "toast_multi_other": "Escolhas guardadas em {{count}} ligas",
    "toast_single": "Escolhas guardadas!",
    "compare_with": "Comparar com {{names}}",
    "compare_default": "Comparar com outros utilizadores (máx {{max}})",
    "tap_to_change": "• toca para alterar",
    "you": "(TU)",
    "matrix_hint": "Toca num ciclista para ver quem o escolheu",
    "user_col": "Utilizador",
    "scout_title": "Relatório de scouting",
    "scout_top_rider": "Corredor mais escolhido",
    "scout_distribution": "Distribuição por slot",
    "scout_variety": "Variedade da liga",
    "scout_distinct": "Corredores distintos escolhidos",
    "scout_identical": "Formações idênticas",
    "scout_no_picks": "Faz as tuas escolhas para veres quantos têm a mesma formação que tu",
    "loading_lineups": "A carregar formações...",
    "collapse_all": "FECHAR TUDO",
    "expand_all": "EXPANDIR TUDO",
    "no_races": "Não há provas disponíveis no momento.",
    "add_rider_one": "+ Adicionar corredor ({{current}}/{{limit}})",
    "duplicate_rider": "{{name}} já foi escalado numa etapa anterior!",
    "draft_count": "Tens {{count}} corredor(es) guardado(s) localmente",
    "toast_multi": "Escolhas guardadas em {{count}} ligas",
    "scout_chosen_by": "Escolhido por: {{names}}",
    "scout_chosen_by_others": "Escolhido por: {{names}} e mais {{count}}",
    "scout_sharing": "A partilhar...",
    "scout_share_btn": "Partilhar relatório de scouting",
    "scout_outsider": "Outsider",
    "scout_contrarian": "Escolha mais corajosa",
    "scout_slot": "SLOT {{n}}",
    "scout_players": "{{count}} jogadores",
    "draft_unsaved_banner": "Escolha não confirmada — carrega em Confirmar para a guardar",
    "draft_unsaved_title": "Escolha não confirmada",
    "draft_unsaved_body": "Tens uma seleção não guardada. Queres confirmar a escolha antes de sair?",
    "draft_exit": "Sair sem guardar",
    "draft_confirm_now": "Ficar e confirmar",
    "share_all": "Todos",
    "current_league": "Liga atual",
    "duplicate_rider_reason": "Já utilizado: {{name}}",
    "flip_saved": "Flip guardado!",
    "flip_deleted": "Flip removido.",
    "flip_add_rider": "+ Adicionar corredor flip (opcional)",
    "riders_count_one": "1 corredor",
    "riders_count_many": "{{count}} corredores",
    "riders_count_other": "{{count}} corredores",
    "riders_selected_one": "1 selecionado",
    "riders_selected_many": "{{count}} selecionados",
    "riders_selected_other": "{{count}} selecionados",
    "search_user": "Procurar utilizador...",
    "tab_per_tappa": "Por etapa",
    "tab_matrice": "Presença dos corredores",
    "matrix_select_riders": "Escolhe os corredores a seguir (máx. 5)",
    "no_picks_riepilogo": "Nenhuma escolha encontrada",
    "no_picks_riepilogo_sub": "Ainda não fizeste escolhas nesta prova.",
    "scout_avg_pct": "~{{pct}}% em média",
    "scout_no_identical": "Mais ninguém tem a mesma formação que tu",
    "scout_identical_count_one": "1 jogador tem a mesma formação que tu",
    "scout_identical_count_many": "{{count}} jogadores têm a mesma formação que tu",
    "scout_identical_count_other": "{{count}} jogadores têm a mesma formação que tu",
    "scout_share_dialog": "Relatório de scouting — {{name}}",
    "share_hidden": "+ MAIS {{count}} JOGADORES · ABRIR A APP",
    "no_picks_tabella": "Nenhuma formação enviada",
    "no_picks_tabella_sub": "As escolhas dos outros jogadores vão aparecer aqui.",
    "flip_slot_arrow": "→ slot {{slot}}",
    "race_tag_pick": "ESCOLHE",
    "race_tag_live": "AO VIVO",
    "race_tag_done": "CONCLUÍDA",
    "race_switcher_label": "Corridas",
    "race_history": "Histórico de corridas",
    "race_group_next": "Próximas",
    "race_group_past": "Passadas",
    "close": "Fechar",
    "prev_stage": "Etapa anterior",
    "next_stage": "Etapa seguinte",
    "stage_list_title": "Etapas",
    "matrix_chosen_by": "{{name}} · escolhido por {{count}} de {{total}}",
    "matrix_clear": "Limpar seleção",
    "matrix_chosen_by_a11y": "escolhido por {{count}} de {{total}} jogadores",
    "matrix_open_player": "Abrir as escolhas de {{name}}",
    "sheet_chosen_by": "{{count}} de {{total}}",
    "sheet_shared": "Igual a ti",
    "sheet_unique": "Escolha única",
    "share_label": "AS ESCOLHAS",
    "share_most_picked": "MAIS ESCOLHIDO",
    "share_unique_picks": "ESCOLHAS ÚNICAS",
    "share_unique_sub": "ciclistas escolhidos por um só",
    "scout2_title": "Scout",
    "scout2_originality": "A TUA ORIGINALIDADE",
    "scout2_twin": "O TEU GÉMEO",
    "scout2_identical": "ESCOLHAS IDÊNTICAS",
    "scout2_identical_sub": "jogadores com a mesma escolha",
    "scout2_bold": "Ousado",
    "scout2_balanced": "Equilibrado",
    "scout2_aligned": "Alinhado",
    "scout2_in_common": "{{count}} de {{total}} em comum",
    "scout2_none": "Nenhum",
    "scout2_popularity": "Popularidade dos ciclistas",
    "scout2_tap_hint": "Toca num ciclista para o destacar na tabela",
    "scout2_your_picks": "As tuas escolhas",
    "scout2_also_by": "Também escolhido por {{names}}",
    "scout2_only_you": "Só tu",
    "scout2_outsiders": "Outsiders",
    "finished_banner": "Corrida terminada · és {{pos}}.º com {{pts}} pts",
    "finished_banner_nopos": "Corrida terminada",
    "finished_cta": "Classificação",
    "scout2_like_you": "Quem jogou como tu",
    "scout2_twins_card": "OS TEUS GÉMEOS",
    "scout2_same_as_you": "{{count}} com a tua mesma escolha",
    "scout2_same_picks": "Mesma escolha",
    "scout2_group_count": "{{count}} jogadores",
    "scout2_no_common": "Nenhum ciclista em comum com",
    "scout2_other_identical": "Outras escolhas idênticas",
    "result_title": "Como correu",
    "result_total": "Fizeste {{pts}} pts",
    "result_pick_line": "previsto {{slot}}.º · chegou {{rank}}.º",
    "result_dnf": "não classificado",
    "result_best": "O teu melhor",
    "result_worst": "O que mais te custou",
    "result_malus": "Vencedor não escolhido",
    "result_bonus_top10": "Todos no top 10",
    "result_bonus_top15": "Todos no top 15",
    "result_winner": "O vencedor",
    "result_winner_owners": "escolhido por {{count}} de {{total}}",
    "result_nobody": "Ninguém o tinha",
    "result_difference": "Fez a diferença",
    "result_difference_sub": "quem o tinha fez em média {{delta}} pts em relação aos outros",
    "result_flop": "Afundou muitos",
    "result_flop_sub": "quem o tinha fez em média {{delta}} pts em relação aos outros",
    "rules_title": "Regras em resumo",
    "rules_1": "Um ciclista por etapa, três nos contrarrelógios.",
    "rules_2": "Um ciclista não pode ser usado duas vezes na mesma corrida.",
    "rules_3": "Se falhares uma única etapa ficas fora da corrida: podes acompanhar, mas não jogar.",
    "rules_flip": "Flip: uma só vez por corrida, indicas um ciclista de reserva; conta no lugar do titular só se chegar melhor.",
    "profile_flat": "Plana",
    "profile_hilly": "Ondulada",
    "profile_mountain": "Montanha",
    "profile_itt": "Contrarrelógio",
    "profile_ttt": "Contrarrelógio por equipas",
    "view_by_rider": "Por ciclista",
    "view_by_player": "Por jogador",
    "tour_summary": "{{riders}} ciclistas escolhidos por {{players}} jogadores",
    "your_pick": "A tua escolha",
    "tour_your_result": "O teu resultado",
    "tour_stage_winner": "Vencedor da etapa",
    "stage_finished_banner": "Etapa terminada · és {{pos}}.º da etapa ({{gap}})",
    "share_label_stage": "AS ESCOLHAS DA ETAPA",
    "share_distinct_riders": "CICLISTAS DIFERENTES",
    "scout_t_position": "ESTÁS NA",
    "scout_t_break": "FUGA",
    "scout_t_small": "PEQUENO GRUPO",
    "scout_t_group": "PELOTÃO",
    "scout_t_with": "com {{count}} jogadores",
    "scout_t_alone": "só tu",
    "scout_t_leader": "O LÍDER ESCOLHEU",
    "scout_t_jerseys": "As camisolas: o que escolheram",
    "scout_t_breakaway": "Na fuga",
    "closes_at": "Fecha {{when}}",
    "closes_in": "Fecha em {{time}}",
    "profile_title": "Perfil altimétrico",
    "profile_climbs": "Subidas",
    "profile_coppi": "C = Cima Coppi",
    "profile_a11y": "Perfil altimétrico: {{km}} km, altitude máxima {{max}} m, {{n}} subidas principais",
    "profile_sprint": "S = sprint intermédio",
    "profile_tap_climb": "Toque numa subida para ver o detalhe",
    "profile_sprint_bonus": "Sprint · bónus",
    "climb_base": "Base",
    "climb_summit": "Cume",
    "climb_avg": "Inclinação média",
    "climb_length": "Extensão",
    "profile_bonus": "B = meta de bónus"
  },
  "join": {
    "back_home": "Voltar ao início",
    "welcome": "Bem-vindo à liga!",
    "already_member": "Já és membro desta liga.",
    "error": "Não foi possível entrar na liga.",
    "joining": "A aceder à liga...",
    "success": "Acesso efetuado!"
  },
  "leaderboard": {
    "stage_cancelled": "Etapa {{n}} anulada: não conta para a classificação",
    "loading": "Carregando...",
    "no_result_title": "Nenhum resultado",
    "no_result_sub": "Os resultados desta prova ainda não estão disponíveis.",
    "gc_rank": "Classificação Geral",
    "team_no_data": "Nenhum dado de equipa para esta etapa.",
    "team_title": "CLASSIFICAÇÃO POR EQUIPAS",
    "stage": "Etapa {{n}}",
    "general": "Geral",
    "stage_rank": "Classificação da Etapa {{n}}",
    "no_data_title": "Dados não disponíveis",
    "no_data_sub": "A classificação desta etapa ainda não foi calculada.",
    "one_day_race": "Prova de um dia",
    "title": "Classificação",
    "no_data": "Nenhum dado disponível.",
    "share": "Partilhar",
    "jersey_tempo": "Tempo",
    "jersey_punti": "Pontos",
    "jersey_gpm": "Montanha",
    "tab_individual": "Individual",
    "tab_team": "Equipa",
    "share_text": "{{name}}\n\n{{text}}\n\n{{site}}",
    "sharing": "...",
    "race_tag_live": "EM CURSO",
    "race_tag_done": "CONCLUÍDA",
    "race_tag_soon": "EM BREVE",
    "leader_label": "De líder",
    "lead_over_second": "{{gap}} sobre o 2.º",
    "winner": "Vencedor",
    "sheet_total": "Total",
    "tie": "empate",
    "top10_count": "{{count}} no top 10",
    "has_winner": "Tem o vencedor",
    "my_rank": "A tua posição",
    "counts_for_team": "Conta para a equipa",
    "not_counting": "Não conta",
    "share_label": "CLASSIFICAÇÃO",
    "gap_above": "{{gap}} do {{pos}}º",
    "gap_below": "{{gap}} sobre o {{pos}}º",
    "trend_up": "Subiu {{n}} posições",
    "trend_down": "Desceu {{n}} posições",
    "trend_same": "Posição inalterada",
    "sheet_by_stage": "Etapa a etapa"
  },
  "leagues": {
    "albo": "Palmarés",
    "no_podio": "ainda não conquistou pódios.",
    "victories": "Vitórias",
    "second": "2º lugar",
    "third": "3º lugar",
    "races_count_one": "1 prova",
    "races_count_many": "{{count}} provas",
    "races_count_other": "{{count}} provas",
    "player_a": "-- Jogador A --",
    "player_b": "-- Jogador B --",
    "draws_one": "1 empate",
    "draws_many": "{{count}} empates",
    "draws_other": "{{count}} empates",
    "on_races_one": "em 1 prova",
    "on_races_many": "em {{count}} provas",
    "on_races_other": "em {{count}} provas",
    "no_common": "Nenhuma prova em comum com resultados.",
    "settings": "DEFINIÇÕES",
    "your_position": "A tua posição",
    "stagionale": "Classificação da Época",
    "hide": "OCULTAR",
    "show_all_one": "MOSTRAR TODOS (mais 1)",
    "show_all_many": "MOSTRAR TODOS (mais {{count}})",
    "show_all_other": "MOSTRAR TODOS (mais {{count}})",
    "no_data": "Ainda não há dados disponíveis.",
    "head2head": "Frente a frente",
    "races_count": "{{count}} provas",
    "draws": "{{count}} empates",
    "on_races": "em {{count}} provas",
    "show_all": "MOSTRAR TODOS (mais {{count}})",
    "badge_empty_1": "Ainda sem emblemas — a glória espera por ti! 🚴",
    "badge_empty_2": "Zero conquistas por agora, mas cada prova é uma oportunidade. 💪",
    "badge_empty_3": "Ainda nenhum emblema — os grandes campeões começam do zero. 🏅",
    "badge_empty_4": "O primeiro emblema é sempre o mais difícil. Estamos quase lá! ⚡",
    "gap_to_podium": "{{gap}} pts do pódio",
    "gap_to_prev": "{{gap}} pts do {{pos}}.º",
    "lead_over_next": "+{{gap}} pts sobre o {{pos}}.º",
    "invite_title": "A jogar sozinho?",
    "invite_body": "Convida os teus amigos para jogarem juntos nesta liga.",
    "invite_cta": "Convidar amigos",
    "pick_member": "Escolhe um jogador",
    "position_a11y": "Posição {{pos}}",
    "load_error": "Não foi possível carregar a liga.",
    "tab_standings": "Classificação",
    "tab_stats": "Estatísticas",
    "tab_rivalry": "Desafios"
  },
  "league": {
    "member_count_one": "1 utilizador nesta liga",
    "member_count_many": "{{count}} utilizadores nesta liga",
    "member_count_other": "{{count}} utilizadores nesta liga",
    "index_join": "Entrar",
    "index_create": "Criar liga",
    "manage_title": "Gestão de {{name}}",
    "err_name": "Insere um nome",
    "err_password": "Insere uma password",
    "err_creation": "Erro na criação",
    "create_title": "Criar nova liga",
    "create": "Criar liga",
    "privacy": "Privacidade",
    "public": "Pública",
    "private": "Privada",
    "err_join": "Erro ou já estás inscrito",
    "join_title": "Entrar numa liga",
    "search_placeholder": "Procurar por nome...",
    "search": "Procurar",
    "no_leagues_found": "Nenhuma liga encontrada",
    "join_btn": "Entrar",
    "password_insert": "Insere a password:",
    "calendar_section": "Calendário",
    "calendar_desc_admin": "Gere as provas da liga",
    "calendar_desc_user": "Provas no calendário",
    "manage": "Gerir",
    "view": "Ver",
    "calendar_title": "Calendário da liga",
    "calendar_save_one": "Guardar calendário (1 prova)",
    "calendar_save_many": "Guardar calendário ({{count}} provas)",
    "calendar_save_other": "Guardar calendário ({{count}} provas)",
    "races_selected_one": "1 prova selecionada",
    "races_selected_many": "{{count}} provas selecionadas",
    "races_selected_other": "{{count}} provas selecionadas",
    "deselect_all": "Desmarcar todas",
    "select_all": "Selecionar todas",
    "loading": "Carregando...",
    "settings_section": "Definições da liga",
    "settings_name": "Nome da liga",
    "settings_save": "Guardar",
    "settings_autopick": "Escolha automática",
    "settings_autopick_desc": "Se um utilizador não fizer a escolha, o sistema escolhe o melhor ciclista disponível da etapa anterior.",
    "settings_team_race": "Prova por equipas",
    "settings_team_race_desc": "Ativa o modo equipa para esta liga.",
    "settings_team_size": "Máx. de membros por equipa",
    "settings_scoring": "Cálculo de pontuação",
    "settings_scoring_best2": "Melhores 2 — soma dos dois primeiros",
    "settings_scoring_avg": "Média de todos os membros",
    "settings_flip": "Flip",
    "settings_flip_desc": "Cada utilizador pode indicar um corredor curinga numa etapa à sua escolha. No cálculo de pontos, será escolhido automaticamente o melhor entre o titular e o flip. Utilizável apenas uma vez por prova.",
    "invite_section": "Link de convite",
    "invite_loading": "Carregando...",
    "invite_copied": "Copiado!",
    "invite_copy": "Copiar",
    "invite_share_btn": "Partilhar",
    "members_section": "Membros",
    "members_title_admin": "Gestão de membros",
    "members_title_user": "Membros da liga",
    "leaving": "A sair...",
    "leave": "Sair desta liga",
    "admin_badge": "Admin",
    "remove": "Remover",
    "pick_admin_title": "Correção de escolhas",
    "pick_admin_desc": "Edita as escolhas dos utilizadores",
    "pick_admin_open": "Abrir",
    "pick_admin_save": "Guardar Escolhas",
    "pick_admin_none": "— nenhum —",
    "pick_admin_search": "Procurar corredor ou dorsal",
    "pick_admin_retired": "desistiu",
    "pick_admin_saved2": "{{set}} picks definidas, {{removed}} removidas",
    "pick_admin_nochange": "Sem alterações para guardar",
    "pick_admin_undo": "Anular a última correção",
    "pick_admin_undone": "Correção anulada",
    "pick_admin_future": "Também foram removidas {{n}} picks de etapas futuras com o mesmo corredor",
    "pick_admin_notify": "Avisar os jogadores",
    "pick_admin_no_calendar": "Esta corrida não está no calendário da liga: não é possível guardar",
    "stats_section": "Estatísticas",
    "stats_participation": "Participação por etapa",
    "stats_title": "Estatísticas de participação",
    "stats_no_data": "Nenhum dado disponível.",
    "stats_error": "Não foi possível carregar as estatísticas. Tenta novamente.",
    "team_loading": "A carregar equipa...",
    "team_section": "Equipa",
    "team_cancel": "Cancelar",
    "team_create_btn": "+ Criar equipa",
    "team_locked": "Prova em curso — alterações de equipa desativadas",
    "team_create": "Criar equipa",
    "team_members_count_one": "1/{{max}} membro",
    "team_members_count_many": "{{count}}/{{max}} membros",
    "team_members_count_other": "{{count}}/{{max}} membros",
    "team_invite_btn": "+ Convidar",
    "team_leave": "Sair",
    "team_save": "Guardar",
    "team_pwd_hint": "Deixa vazio para tornar pública",
    "team_pending": "A aguardar resposta",
    "team_invite_cancel": "Cancelar",
    "team_invite_section": "Convidar um membro",
    "team_no_invitable": "Nenhum membro disponível para convidar.",
    "team_invite_action": "Convidar",
    "team_private_label": "\"{{name}}\" é privada:",
    "team_join_action": "Entrar",
    "team_empty": "Ainda não há equipas — sê o primeiro a criar uma!",
    "team_mine": "A TUA",
    "team_join": "Entrar",
    "team_full": "Completa",
    "team_members": "Membros",
    "join": "Entrar",
    "calendar_save": "Guardar calendário ({{count}} provas)",
    "invite_share": "Partilhar",
    "races_selected": "{{count}} provas selecionadas",
    "invite_desc": "Partilha este link — quem clicar entra diretamente na liga.",
    "invite_desc_pwd": "Partilha este link — quem clicar entra diretamente na liga com a password já incluída.",
    "member_count": "{{count}} utilizadores nesta liga",
    "team_members_count": "{{count}}/{{max}} membros",
    "create_name_placeholder": "Ex: Os Amigos do Pedal",
    "create_password_placeholder": "Password de acesso",
    "calendar_saved": "Calendário guardado!",
    "err_name_empty": "O nome não pode estar vazio",
    "settings_saved": "Definições guardadas!",
    "pwd_public_placeholder": "Deixa vazio para uma liga pública",
    "invite_share_title": "Junta-te a {{name}} no Virtua Cycling",
    "invite_share_message": "Junta-te à liga \"{{name}}\" no Virtua Cycling!\n{{url}}",
    "invite_regen_confirm": "Regenerar o link? Todos os links anteriores deixarão de funcionar.",
    "invite_regenerating": "A regenerar...",
    "invite_regen_btn": "Regenerar link (revoga os anteriores)",
    "confirm_remove": "Remover {{name}} da liga?",
    "member_removed": "{{name}} removido",
    "confirm_demote": "Queres retirar os privilégios de admin a {{name}}?",
    "confirm_promote": "Queres promover {{name}} a admin?",
    "demote_admin": "Remover Admin",
    "promote_admin": "Admin",
    "pick_admin_saved": "{{count}} escolhas guardadas!",
    "confirm_team_leave": "Sair da equipa?",
    "confirm_kick": "Remover {{name}} da equipa?",
    "team_invite_sent": "Convite enviado!",
    "team_pwd_saved": "Password atualizada!",
    "team_name_placeholder": "Nome da equipa...",
    "team_rename_placeholder": "Novo nome...",
    "team_newpwd_placeholder": "Nova password..."
  },
  "profile": {
    "nick_title": "Alcunha",
    "theme_title": "Personalização do Tema",
    "theme_dark": "Escuro",
    "theme_light": "Claro",
    "lang": "Idioma",
    "save_lang": "Guardar idioma",
    "nick_success": "Alcunha atualizada!",
    "nick": "Alcunha",
    "nick_placeholder": "Insere a alcunha",
    "update_btn": "Atualizar",
    "pass": "Password",
    "show_pass": "Mostrar password",
    "update_pass": "Atualizar password",
    "avatars_title": "Avatares",
    "avatars": "Mostrar avatares",
    "avatars_sub": "Desativa se o telemóvel estiver lento: em vez dos avatares verás a camisola dos ciclistas e o nome dos jogadores. O teu avatar no Início mantém-se.",
    "notif_title": "Notificações Push",
    "my_leagues": "As minhas ligas",
    "members_count_one": "1 membro",
    "members_count_many": "{{count}} membros",
    "members_count_other": "{{count}} membros",
    "default_badge": "PREDEFINIDA",
    "set_default": "Definir como predefinida",
    "leave": "Sair",
    "settings": "Definições do Perfil",
    "hi": "Olá",
    "intro": "aqui podes gerir a tua conta.",
    "admin_panel": "Painel de Administração",
    "theme_sub": "Sincronizado em todos os teus dispositivos.",
    "lang_title": "Idioma / Language",
    "security_title": "Acesso e Segurança",
    "security_success": "Dados atualizados!",
    "notif_enabled": "Ativar notificações",
    "notif_enabled_sub": "Ativa ou desativa todas as notificações",
    "notif_results": "Resultados da prova",
    "notif_results_sub": "Notificação quando os resultados forem publicados",
    "notif_startlist": "Lista de partida",
    "notif_startlist_sub": "Notificação assim que a lista de partida estiver disponível",
    "notif_reminder": "Lembrete de escolha",
    "notif_reminder_sub": "Recebe um lembrete antes do encerramento das escolhas",
    "notif_reminder_off": "Sem lembrete",
    "notif_reminder_no_pick": "Só se ainda não escolhi",
    "notif_reminder_always": "Sempre",
    "notif_saving": "A guardar...",
    "notif_saved": "Preferências guardadas!",
    "notif_error": "Erro ao guardar",
    "nick_taken": "Alcunha já em uso",
    "pass_min_length": "A password deve ter pelo menos 6 caracteres",
    "pass_mismatch": "As passwords não coincidem",
    "new_pass_placeholder": "Nova password",
    "league_default_updated": "Liga predefinida atualizada!",
    "league_leave_confirm": "Tens a certeza de que queres sair de \"{{name}}\"?",
    "league_left": "Liga abandonada.",
    "confirm_password": "Confirma a password",
    "avatar_title": "O teu avatar",
    "avatar_jersey": "Camisola",
    "avatar_cap": "Boné",
    "avatar_glasses": "Óculos",
    "avatar_cyclist": "Ciclista",
    "avatar_patch": "Emblema da camisola",
    "avatar_saved": "Avatar guardado!",
    "avatar_save_btn": "Guardar avatar",
    "rules": "Regulamento",
    "report_bug": "Reportar um problema",
    "bug_sent": "Reporte enviado, obrigado!",
    "bug_placeholder": "Descreve o problema...",
    "group_identity": "Identidade",
    "group_account": "Conta",
    "group_contact": "Fale connosco",
    "group_danger": "Zona de perigo",
    "change_pass": "Alterar",
    "cancel": "Cancelar",
    "show_more": "Mostrar todas (mais {{count}})",
    "show_less": "Mostrar menos",
    "delete_confirm": "Tens a certeza de que queres eliminar a tua conta? Esta ação é irreversível e todos os teus dados serão eliminados definitivamente.",
    "delete_desc": "A eliminação é permanente e remove todos os teus dados, escolhas, ligas e preferências.",
    "delete_btn": "Eliminar a minha conta",
    "delete_league_owner": "Criaste uma liga com outros membros: ao eliminar a conta ela desapareceria para todos. Contacta-nos para a transferir ou elimina-a antes.",
    "replay_tour": "Rever o tour",
    "leave_feedback": "Deixar feedback",
    "feedback_placeholder": "Uma ideia, uma sugestão ou um comentário: gostamos de te ler...",
    "feedback_sent": "Obrigado pelo teu feedback! 🙏",
    "rate_app": "Avaliar Virtua Cycling ⭐"
  },
  "login": {
    "err_nickname": "Insere uma alcunha",
    "err_nickname_taken": "Alcunha já em uso",
    "register_ok": "Registration completed! Check your email and confirm your account before logging in.",
    "err_email": "Insere o teu email",
    "forgot_sent": "Email enviado! Verifica a tua caixa de entrada.",
    "tagline": "Ocupa o teu lugar no carro vassoura.",
    "tab_login": "Entrar",
    "tab_register": "Registar",
    "forgot_hint": "Insere o teu email e enviamos-te um link para redefinir a password.",
    "email": "Email",
    "forgot_send": "Enviar link",
    "back": "← Voltar ao login",
    "nickname": "Alcunha",
    "password": "Password",
    "btn_login": "ENTRAR",
    "btn_register": "REGISTAR",
    "forgot_pass": "Esqueceste-te da password?",
    "or": "ou",
    "google_login": "Entrar com Google",
    "google_register": "Registar com Google",
    "privacy_text": "Ao continuar, aceitas a nossa",
    "privacy_link": "Política de Privacidade",
    "loading": "…"
  },
  "news": {
    "title": "NOTÍCIAS",
    "loading": "Carregando...",
    "no_news": "Nenhuma notícia disponível.",
    "pinned": "Em destaque",
    "not_found": "Artigo não encontrado.",
    "open_external": "Abrir o artigo em {{source}}",
    "disclaimer": "Títulos e ligações vêm de fontes externas: os artigos pertencem aos respetivos editores.",
    "tab_unread_one": "{{count}} notícia nova",
    "tab_unread_other": "{{count}} notícias novas",
    "load_error": "Não foi possível carregar as notícias."
  },
  "reset_password": {
    "title": "NOVA PASSWORD",
    "subtitle": "Escolhe uma nova password para a tua conta",
    "show_pass": "Mostrar password",
    "loading": "A verificar o link...",
    "success": "Password atualizada! Vais ser redirecionado..."
  },
  "confirm": {
    "verifying": "A verificar...",
    "error": "Erro durante a confirmação.",
    "success": "Email confirmado! Vais ser redirecionado...",
    "missing_params": "Parâmetros em falta no link.",
    "missing_params_detail": "Certifica-te de que clicaste no link correto do teu email.",
    "critical_error": "Erro crítico de ligação."
  },
  "notifications": {
    "title": "Notificações",
    "empty": "Ainda sem notificações",
    "accept": "Aceitar",
    "refuse": "Recusar",
    "now": "Agora",
    "minutes_ago": "há {{count}} min",
    "hours_ago": "há {{count}}h"
  },
  "quiz": {
    "card_sub": "10 perguntas sobre o Tour de France — quanto sabes?",
    "loading": "A carregar perguntas...",
    "no_questions": "Nenhuma pergunta disponível",
    "question_count": "Pergunta {{current}} de {{total}}",
    "easy": "Fácil",
    "medium": "Médio",
    "hard": "Difícil",
    "correct": "Resposta correta!",
    "wrong": "Errado. A resposta era: {{answer}}",
    "next": "Seguinte",
    "see_result": "Ver resultado",
    "restart": "Jogar novamente",
    "result_excellent": "És um verdadeiro especialista em ciclismo!",
    "result_good": "Excelente conhecimento do Tour de France!",
    "result_average": "Conhecimento razoável. Vê mais provas!",
    "result_poor": "Há margem de progressão — mas é para isso que se pedala!"
  },
  "person": {
    "hint": "Escolhe o aspeto do teu avatar: vais vê-lo no ecrã inicial.",
    "gender": "Género",
    "man": "Homem",
    "woman": "Mulher",
    "hair_short": "Curto",
    "hair_curly": "Encaracolado",
    "hair_wavy": "Ondulado",
    "hair_shaved": "Rapado",
    "hair_pixie": "Pixie",
    "hair_bob": "Bob",
    "headwear": "Cobertura",
    "wear_none": "Nenhuma",
    "wear_cap": "Boné",
    "wear_helmet": "Capacete",
    "glasses": "Óculos",
    "glasses_off": "Não",
    "glasses_on": "Sim",
    "jersey": "Camisola",
    "jersey_vertical": "Vertical",
    "jersey_horizontal": "Horizontal",
    "jersey_classic": "Clássica",
    "jersey_diagonal": "Diagonal",
    "jersey_dots": "Bolinhas",
    "row_skin": "Pele",
    "row_hair": "Cabelo",
    "row_brow": "Sobrancelhas",
    "row_iris": "Olhos",
    "row_wear": "Cobertura",
    "row_visor": "Pala",
    "row_vents": "Ventilações",
    "row_frame": "Armação dos óculos",
    "save": "GUARDAR",
    "saved": "Avatar guardado",
    "save_error": "Erro ao guardar",
    "reset": "Repor",
    "reset_done": "Reposto",
    "tab_face": "Rosto",
    "tab_hair": "Cabelo",
    "tab_gear": "Acessórios",
    "tab_jersey": "Camisola",
    "row_lens": "Lentes",
    "jersey_body": "Corpo",
    "jersey_sleeves": "Mangas",
    "jersey_band": "Faixa",
    "jersey_trim": "Gola e punhos",
    "view_mine": "Meu avatar",
    "view_world_champion": "Camisola arco-íris",
    "world_champion_since": "Campeão do mundo em {{league}} desde {{date}}",
    "view_european_champion": "Camisola europeia",
    "european_champion_since": "Campeão europeu em {{league}} desde {{date}}",
    "view_worldcup_leader": "Camisola da Taça do Mundo",
    "worldcup_leader_since": "Líder da classificação de {{league}} desde {{date}}",
    "kits_show": "Show team kits (admin)",
    "kits_hide": "Hide team kits",
    "kits_hint": "Team jerseys imported from PCS: check colours and design. Kits are fixed in the database.",
    "kits_approx": "approximate",
    "kits_men": "Men",
    "kits_women": "Women",
    "kits_wt": "WorldTeam",
    "kits_pro": "ProTeam",
    "kits_tap": "tap a team to see its riders",
    "kits_no_riders": "No avatars for this team yet.",
    "avatar_edit": "Editar avatar",
    "avatar_cut": "Corte",
    "avatar_hair": "Cabelo",
    "avatar_skin": "Pele",
    "avatar_beard": "Barba",
    "avatar_beard_none": "Nenhuma",
    "avatar_face": "Rosto",
    "avatar_face_none": "Padrão",
    "avatar_face_a": "Magro",
    "avatar_face_b": "Robusto",
    "avatar_face_c": "Jovem",
    "avatar_face_d": "Anguloso",
    "avatar_face_e": "Maduro",
    "avatar_face_f": "Sorridente",
    "avatar_face_g": "Sorriso fechado",
    "avatar_brow": "Sobrancelhas",
    "avatar_brow_0": "Normais",
    "avatar_brow_1": "Finas",
    "avatar_brow_2": "Grossas",
    "avatar_beard_light": "Leve",
    "avatar_hex": "Outra cor (#RRGGBB)",
    "avatar_save": "Guardar",
    "avatar_reset": "Repor",
    "avatar_undo": "Anular última alteração",
    "avatar_saved": "Guardado",
    "avatar_bad_hex": "Cor inválida: usa #RRGGBB",
    "avatar_err": "Erro ao guardar",
    "avatar_beard_legend": "1 sombra · 2 bigode · 3 curta · 4 cheia · 6 bigode+cavanhaque · 7 circular · 8 sombra leve",
    "hair_wavy_medium": "Ondulado médio",
    "hair_receding": "Entradas",
    "hair_messy": "Desgrenhado",
    "hair_buzz": "Muito curto",
    "hair_curly_short": "Cachos curtos",
    "hair_medium": "Pelos ombros",
    "hair_flip_off": "Lado normal",
    "hair_flip_on": "Invertido",
    "hair_side_part": "Risca ao lado",
    "hair_slicked_back": "Para trás",
    "hair_forward": "Para a frente",
    "hair_high_line": "Entradas altas",
    "hair_wavy_short": "Ondulado curto",
    "hair_curly_medium": "Caracóis médios",
    "hair_receding_short": "Entradas curtas",
    "beard_stubble_light": "Sombra leve",
    "hair_long": "Longo",
    "hair_ponytail": "Rabo de cavalo",
    "hair_bun": "Coque",
    "hair_long_wavy": "Ondulado",
    "hair_braid": "Trança",
    "beard": "Barba",
    "beard_none": "Nenhuma",
    "beard_stubble": "Sombra",
    "beard_moustache": "Bigode",
    "beard_short": "Curta",
    "beard_full": "Cheia",
    "beard_goatee": "Bigode e cavanhaque",
    "beard_circle": "Circular",
    "beard_op_normal": "Normal",
    "beard_op_light": "Leve",
    "fringe": "Franja",
    "fringe_off": "Sem",
    "fringe_on": "Com franja"
  },
  "app_update": {
    "title": "Nova versão pronta",
    "body": "Reinicia a app para usar as novidades.",
    "restart": "Reiniciar",
    "later": "Mais tarde"
  },
  "avatar": {
    "invite_title": "Aqui está o teu avatar!",
    "invite_body": "Criámos um para ti: personaliza-o como quiseres.",
    "invite_cta": "Personalizar",
    "invite_dismiss": "Fechar",
    "edit_a11y": "Personaliza o teu avatar"
  },
  "jersey_celebration": {
    "ok": "Fantástico!"
  },
  "insight": {
    "you": "Contigo",
    "form": "Forma",
    "never": "Nunca o escolheste: seria a primeira vez.",
    "picked": "Vezes escolhido",
    "avg_rank": "Posição média",
    "avg_gap": "Diferença média",
    "best": "Melhor resultado",
    "dnf": "Desistências contigo",
    "last": "Última vez",
    "retired": "desistiu",
    "form_avg": "Média das últimas 5",
    "season_races": "Corridas na temporada",
    "top10": "Top 10",
    "wins": "Vitórias",
    "dnfs": "Desistências",
    "cat_1": "Etapas planas",
    "cat_2": "Etapas de montanha",
    "cat_3": "Etapas onduladas",
    "last5": "Últimos 5 resultados",
    "no_results": "Ainda sem resultados nesta temporada.",
    "open_a11y": "Estatísticas de {{name}}",
    "summary": "{{n}}× contigo · média {{rank}}°",
    "summary_never": "Nunca escolhido por ti",
    "open": "Insights"
  },
  "badges": {
    "title": "Emblemas",
    "album_title": "Galeria de troféus",
    "earned_of": "{{earned}} de {{total}} emblemas",
    "open_album": "Abrir a galeria de troféus",
    "recent": "Últimos conquistados",
    "next_goals": "Metas ao alcance",
    "filter_all": "Todos",
    "filter_earned": "Conquistados",
    "filter_todo": "Por conquistar",
    "group_gt": "Grandes Voltas",
    "group_monuments": "Monumentos e clássicas",
    "group_picks": "Habilidade nas escolhas",
    "group_consistency": "Constância",
    "group_league": "Classificação da liga",
    "group_social": "Social",
    "group_meta": "Coleção",
    "tier_1": "Bronze",
    "tier_2": "Prata",
    "tier_3": "Ouro",
    "tier_4": "Platina",
    "tier_special": "Marco",
    "secret_title": "Emblema secreto",
    "secret_hint": "Descobre-o a jogar.",
    "earned_on": "Conquistado em {{date}}",
    "progress": "{{value}} de {{threshold}}",
    "rarity": "{{pct}}% da liga tem-no ({{n}} de {{m}})",
    "rarity_none": "Ninguém o tem ainda: podes ser o primeiro.",
    "seasons": "Épocas conquistadas: {{count}}",
    "complete": "Concluído",
    "locked": "Por conquistar",
    "player": "Jogador",
    "none_me": "Ainda sem emblemas: a próxima corrida é a tua oportunidade.",
    "none_other": "{{name}} ainda não tem emblemas.",
    "empty_filter": "Nada para mostrar com este filtro.",
    "load_error": "Não foi possível carregar os emblemas.",
    "not_enabled": "Os emblemas ainda não estão ativos nesta liga.",
    "fam": {
      "RE_GT": {
        "title": "Rei das Grandes Voltas",
        "desc": "Grandes Voltas ganhas: {{n}}"
      },
      "WIN_GIRO": {
        "title": "Rei do Giro",
        "desc": "Ganha a classificação geral do Giro d'Italia"
      },
      "WIN_TOUR": {
        "title": "Rei do Tour",
        "desc": "Ganha a classificação geral do Tour de France"
      },
      "WIN_VUELTA": {
        "title": "Rei da Vuelta",
        "desc": "Ganha a classificação geral da Vuelta"
      },
      "GT_PODI": {
        "title": "Pódios nas Grandes Voltas",
        "desc": "Pódios em Grandes Voltas: {{n}}"
      },
      "GT_DAYS": {
        "title": "Dias de camisola",
        "desc": "Dias como líder da classificação geral: {{n}}"
      },
      "FIRST_PINK": {
        "title": "Maglia rosa",
        "desc": "Torna-te líder da classificação geral do Giro d'Italia"
      },
      "FIRST_YELLOW": {
        "title": "Camisola amarela",
        "desc": "Torna-te líder da classificação geral do Tour de France"
      },
      "FIRST_RED": {
        "title": "Camisola vermelha",
        "desc": "Torna-te líder da classificação geral da Vuelta"
      },
      "GT_GREEN": {
        "title": "Rei dos velocistas",
        "desc": "Classificações por pontos ganhas em Grandes Voltas: {{n}}"
      },
      "GT_POIS": {
        "title": "Rei da montanha",
        "desc": "Classificações da montanha ganhas em Grandes Voltas: {{n}}"
      },
      "GT_STAGE_WINS": {
        "title": "Caçador de etapas",
        "desc": "Etapas ganhas em Grandes Voltas: {{n}}"
      },
      "GT_WIRE": {
        "title": "Do início ao fim",
        "desc": "Lidera a geral da primeira à última etapa e ganha a Grande Volta"
      },
      "GT_COMEBACK": {
        "title": "Reviravolta",
        "desc": "Ganha uma Grande Volta estando fora do top 10 após a primeira semana"
      },
      "GT_TRIPLE_JERSEY": {
        "title": "Triunfo total",
        "desc": "Ganha geral, pontos e montanha na mesma Grande Volta"
      },
      "GT_HEARTBREAK": {
        "title": "A desilusão",
        "desc": "Eras líder na véspera da última etapa, mas não ganhaste a Grande Volta"
      },
      "TRIPLE_CROWN": {
        "title": "Triple Crown",
        "desc": "Ganha Giro, Tour e Vuelta"
      },
      "THE_DOUBLE": {
        "title": "The Double",
        "desc": "Ganha Giro e Tour no mesmo ano"
      },
      "RE_MONUMENTI": {
        "title": "Rei dos Monumentos",
        "desc": "Monumentos ganhos: {{n}}"
      },
      "WIN_SANREMO": {
        "title": "La Classicissima",
        "desc": "Ganha a Milão-Sanremo"
      },
      "WIN_FIANDRE": {
        "title": "O Tour da Flandres",
        "desc": "Ganha o Tour da Flandres"
      },
      "WIN_ROUBAIX": {
        "title": "O Inferno do Norte",
        "desc": "Ganha a Paris-Roubaix"
      },
      "WIN_LIEGI": {
        "title": "La Doyenne",
        "desc": "Ganha a Liège-Bastogne-Liège"
      },
      "WIN_LOMBARDIA": {
        "title": "A clássica das folhas mortas",
        "desc": "Ganha o Giro da Lombardia"
      },
      "MONUMENTS_SWEEP": {
        "title": "Pleno dos Monumentos",
        "desc": "Ganha os 5 Monumentos"
      },
      "RE_DEL_NORD": {
        "title": "Rei do Norte",
        "desc": "Ganha Flandres e Roubaix no mesmo ano"
      },
      "ARDENNES": {
        "title": "Triplete das Ardenas",
        "desc": "Ganha Amstel, Flèche Wallonne e Liège no mesmo ano"
      },
      "DUE_MARI": {
        "title": "Corrida dos dois mares",
        "desc": "Ganha Paris-Nice e Tirreno-Adriático no mesmo ano"
      },
      "MODALITA_POGACAR": {
        "title": "Modo Pogačar",
        "desc": "Ganha as 3 Grandes Voltas e os 5 Monumentos"
      },
      "RE_CLASSICHE": {
        "title": "Rei das Clássicas",
        "desc": "Clássicas ganhas: {{n}}"
      },
      "RE_TAPPE": {
        "title": "Rei das corridas por etapas",
        "desc": "Corridas por etapas ganhas: {{n}}"
      },
      "WORLD_CHAMP": {
        "title": "Campeão do Mundo",
        "desc": "Ganha a prova de estrada dos Mundiais"
      },
      "EURO_CHAMP": {
        "title": "Campeão da Europa",
        "desc": "Ganha a prova de estrada dos Europeus"
      },
      "CRONOMAN": {
        "title": "Contrarrelogista",
        "desc": "Ganha um contrarrelógio dos Mundiais ou dos Europeus"
      },
      "SOLO_WIN": {
        "title": "Solo Win",
        "desc": "Único da liga a escolher o vencedor: {{n}}"
      },
      "PROFETA": {
        "title": "Profeta",
        "desc": "Escolhas vencedoras: {{n}}"
      },
      "FIUTO": {
        "title": "Faro",
        "desc": "Vencedores escolhidos por poucos: {{n}}"
      },
      "LEAGUE_WINS": {
        "title": "Vencedor de corrida",
        "desc": "Corridas ganhas na liga: {{n}}"
      },
      "LEAGUE_PODI": {
        "title": "Habitué do pódio",
        "desc": "Pódios de corrida na liga: {{n}}"
      },
      "DEBUTTO": {
        "title": "Estreia",
        "desc": "Joga a tua primeira corrida"
      },
      "PRESENZE": {
        "title": "Presenças",
        "desc": "Corridas jogadas: {{n}}"
      },
      "SERIE": {
        "title": "Em série",
        "desc": "Corridas seguidas jogadas: {{n}}"
      },
      "STAGIONE_PERFETTA": {
        "title": "Época perfeita",
        "desc": "Joga todas as corridas da época"
      },
      "LEADER_STAGIONE": {
        "title": "No comando",
        "desc": "Corridas terminadas no comando da classificação: {{n}}"
      },
      "CAMPIONE_LEGA": {
        "title": "Campeão da liga",
        "desc": "Termina a época no primeiro lugar da classificação"
      },
      "PODIO_LEGA": {
        "title": "Pódio da liga",
        "desc": "Termina a época no pódio da classificação"
      },
      "TOP10_LEGA": {
        "title": "Top 10",
        "desc": "Termina a época entre os 10 primeiros da classificação"
      },
      "SCALATORE": {
        "title": "Trepador",
        "desc": "Posições ganhas numa só corrida: {{n}}"
      },
      "AMMAZZAGIANTI": {
        "title": "Mata-gigantes",
        "desc": "Corridas terminadas à frente do líder da classificação: {{n}}"
      },
      "ALBUM": {
        "title": "Álbum",
        "desc": "Emblemas conquistados: {{n}}"
      },
      "LEGGENDA": {
        "title": "Lenda",
        "desc": "Conquista todos os emblemas"
      }
    },
    "celebration_one": "Novo emblema!",
    "celebration_many": "{{n}} novos emblemas!",
    "celebration_more": "e mais {{n}}",
    "share": "Partilhar",
    "share_label": "EMBLEMA CONQUISTADO",
    "share_dialog": "O meu emblema: {{name}}",
    "share_text": "Conquistei o emblema «{{name}}» no Virtua Cycling! {{site}}",
    "showcase_title": "Em destaque",
    "showcase_hint": "Escolhe até 3 emblemas para exibir. Se não escolheres, mostramos os mais raros que tens.",
    "showcase_edit": "Editar",
    "showcase_auto": "Automática",
    "showcase_save": "Guardar",
    "showcase_count": "{{n}} de 3 escolhidos",
    "showcase_err": "Não foi possível guardar a seleção.",
    "showcase_a11y": "Os teus emblemas em destaque",
    "showcase_none": "Conquista o teu primeiro emblema para o veres aqui.",
    "showcase_pick_empty": "Ainda não tens emblemas para a vitrine.",
    "jerseys_title": "Camisolas das Grandes Voltas",
    "jersey_pink": "Maglia rosa",
    "jersey_yellow": "Camisola amarela",
    "jersey_red": "Camisola vermelha",
    "days_caption": "Dias de camisola",
    "section_jerseys": "Camisolas",
    "special_title": "Camisolas especiais",
    "special_now": "Em uso",
    "trophy_sub": "Emblemas, camisolas e quadro de honra"
  },
  "rivalry": {
    "title": "Desafios",
    "intro": "Escolhe um adversário. Se aceitar, a partir dessa corrida ganha o ponto quem terminar à frente do outro. Toda a liga vê como está.",
    "slots": "Desafios lançados: {{used}} de {{max}}",
    "limit_reached": "Lançaste o máximo de desafios. Cancela ou termina um para lançar outro.",
    "no_candidates": "Não há outros jogadores para desafiar.",
    "challenge_cta": "Lançar um desafio",
    "pick_title": "Quem queres desafiar?",
    "confirm_challenge": "Desafiar {{name}}? Vai receber o pedido e poderá aceitar ou recusar.",
    "sent": "Pedido enviado a {{name}}.",
    "accepted": "Aceitaste o desafio com {{name}}.",
    "incoming_title": "Pedidos recebidos",
    "incoming_line": "{{name}} desafia-te",
    "accept": "Aceitar",
    "decline": "Recusar",
    "waiting_title": "A aguardar resposta",
    "waiting_line": "A aguardar {{name}}",
    "cancel": "Cancelar",
    "mine_title": "Os teus desafios",
    "league_title": "Na liga",
    "ended_title": "Desafios terminados: {{count}}",
    "empty": "Nenhum desafio a decorrer na liga. Lança o primeiro!",
    "vs": "contra",
    "score_a11y": "{{a}} a {{b}}",
    "last_point": "Último ponto: {{name}} em {{race}}",
    "no_races": "Ainda sem corridas",
    "won_by": "Ganho por {{name}}",
    "drawn": "Terminou empatado",
    "detail_title": "Desafio",
    "results_title": "Corrida a corrida",
    "no_results": "Ainda não foi atribuído nenhum ponto.",
    "point_to": "Ponto para {{name}}",
    "end_cta": "Terminar o desafio",
    "end_confirm": "Terminar o desafio com {{name}}?",
    "rematch": "Desforra",
    "load_error": "Não foi possível carregar os desafios.",
    "err_limit": "Já lançaste o máximo de desafios.",
    "err_exists": "Já estão num desafio, ou há um pedido em curso.",
    "err_invalid": "Este pedido já não é válido.",
    "err_generic": "Não foi possível concluir a ação.",
    "notif_accepted": "Desafio aceite",
    "notif_declined": "Desafio recusado"
  },
  "competition": {
    "men": "Men Elite",
    "women": "Women Elite",
    "aria": "Competição"
  },
  "no_league": {
    "title": "Não participas em nenhuma liga {{comp}}",
    "body": "Podes juntar-te a uma liga ou criar uma nova na secção Ligas.",
    "body_official": "Podes entrar na liga oficial quando quiseres, ou juntar-te ou criar uma liga privada na secção Ligas.",
    "join": "Entrar em {{name}}",
    "go_leagues": "Ir para as ligas"
  }
}
